// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"7d26d33e","299":"99dbae11","387":"8a774302","449":"3d1fa0b2","480":"03657791","732":"7be6c537","977":"209f3b59"}[chunkId] + ".chunk.js";
};